import squelcheeCry from "/images/cancelFlow/squelchee_cry.png"
import squelcheeFrown from "/images/cancelFlow/squelchee_frown.png"
import squelcheeHappy from "/images/cancelFlow/squelchee_happy.png"
import squelcheeShock from "/images/cancelFlow/squelchee_shock.png"
import squelcheeThink from "/images/cancelFlow/squelchee_think.png"
import squelcheeSmile from "/images/cancelFlow/squelchee_smile.png"

import { CancelFlowStep, CancelFlowStepType } from "../types/cancelFlow"

export const getSquelcheeImageUrl = ({
  step,
  isLoading,
  isCancelling,
  isSuccess,
  isCancellingSuccess,
}: {
  step: CancelFlowStep
  isLoading?: boolean
  isCancelling?: boolean
  isSuccess?: boolean
  isCancellingSuccess?: boolean
}) => {
  if (isLoading) return squelcheeSmile // is doing anything but cancelling (pause, extend trial, accept special offer)
  if (isCancelling) return squelcheeFrown // is cancelling
  if (isSuccess) return squelcheeHappy // successfully did anything but cancel (pause, extend trial, accept special offer)
  if (isCancellingSuccess) return squelcheeCry // successfully cancelled

  switch (step.type) {
    case CancelFlowStepType.PAUSE_SUBSCRIPTION:
      return squelcheeFrown
    case CancelFlowStepType.EXTEND_TRIAL:
    case CancelFlowStepType.SURVEY:
      return squelcheeThink
    case CancelFlowStepType.SPECIAL_OFFER:
      return squelcheeShock
    case CancelFlowStepType.CANCEL:
      return squelcheeCry
    default:
      return squelcheeSmile
  }
}
